import React from "react";
import { Icon } from "@iconify/react";

import "./style.css";

const DevelopersCard = ({
  fullName,
  job,
  phone,
  email,
  telegram,
  website,
  image,
  linkedin,
}) => {
  return (
    <div className="developers_card">
      <div className="developers_card_header">
        <img
          src={image}
          alt={`${fullName}'s avatar`}
          className="developers_card_image"
        />
      </div>
      <div className="developers_card_body">
        <h3 className="developers_card_name">{fullName}</h3>
        <p className="developers_card_job">{job}</p>
      </div>
      <div className="developers_card_footer">
        {phone && (
          <a
            href={`tel:${phone}`}
            className="developers_card_info_item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:phone" className="developers_card_icon" />
            <span>{phone}</span>
          </a>
        )}
        {email && (
          <a
            href={`mailto:${email}`}
            className="developers_card_info_item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:email" className="developers_card_icon" />
            <span>{email}</span>
          </a>
        )}
        {telegram && (
          <a
            href={`https://t.me/${telegram}`}
            className="developers_card_info_item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:telegram" className="developers_card_icon" />
            <span>{telegram}</span>
          </a>
        )}
        {website && (
          <a
            href={`https://${website}`}
            className="developers_card_info_item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:web" className="developers_card_icon" />
            <span>{website}</span>
          </a>
        )}
        {linkedin && (
          <a
            href={`${linkedin}`}
            className="developers_card_info_item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:linkedin" className="developers_card_icon" />
            <span>{fullName}</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default DevelopersCard;
